import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddSectionComponent } from './add-section/add-section.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SectionsComponent } from './sections.component';
import { EditSectionComponent } from './edit-section/edit-section.component';
@NgModule({
	declarations: [
    AddSectionComponent,
	SectionsComponent,
 	EditSectionComponent
  ],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		MaterialModule,
	],
	exports: [AddSectionComponent, SectionsComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SectionsModule { }
